var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tag',{class:['tag', _vm.type, _vm.size, _vm.round ? 'round': '', _vm.outline ? 'outline' : ''],style:({color: _vm.color}),attrs:{"closable":_vm.closable,"color":_vm.bgColor},on:{"click":_vm.handleClick,"close":_vm.onTagClose}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }